export default [{
		name: '四川城市职业学院',
		logo: '/file/lineLogo/9.png',
		href: 'https://www.scuvc.edu.cn'
	}, {
		name: '国家智慧教育公共服务平台',
		logo: '/file/lineLogo/2.png',
		href: 'https://higher.smartedu.cn/'
	},
	{
		name: '超星课程平台',
		logo: '/file/lineLogo/11.png',
		href: 'http://scuvc.fy.chaoxing.com/portal'
	},
	{
		name: '重庆城市管理职业学院',
		logo: '/file/lineLogo/3.png',
		href: 'https://www.cqc.edu.cn'
	},
	{
		name: '上海福祉实业有限公司',
		logo: '/file/lineLogo/5.png',
		href: 'http://www.furoto.net'
	},
	{
		name: '成都市第二社会福利院',
		logo: '/file/lineLogo/4.png',
		href: 'http://www.cd2fly.com'
	},
	{
		name: '四川必顾养老信息咨询有限公司',
		logo: '/file/lineLogo/6.png',
		href: 'http://www.biguyanglao.cn/'
	},

	{
		name: '育见未来',
		logo: '/file/lineLogo/10.png',
		href: 'http://yjwledu.cn'
	}
]